// FETCH ALL PROPERTIES FROM TEAM MASTER
export const FETCH_DYEING_DC_REQUEST = 'FETCH_DYEING_DC_REQUEST';
export const FETCH_DYEING_DC_SUCCESS = 'FETCH_DYEING_DC_SUCCESS';
export const FETCH_DYEING_DC_FAILURE = 'FETCH_DYEING_DC_FAILURE';

// FETCH ALL PROPERTIES FROM TEAM MASTER
export const FETCH_DYEING_DC_STYLE_REQUEST = 'FETCH_DYEING_DC_STYLE_REQUEST';
export const FETCH_DYEING_DC_STYLE_SUCCESS = 'FETCH_DYEING_DC_STYLE_SUCCESS';
export const FETCH_DYEING_DC_STYLE_FAILURE = 'FETCH_DYEING_DC_STYLE_FAILURE';

// CREATE PROPERTIES FOR TEAM MASTER
export const CREATE_DYEING_DC_REQUEST = 'CREATE_DYEING_DC_REQUEST';
export const CREATE_DYEING_DC_SUCCESS = 'CREATE_DYEING_DC_SUCCESS';
export const CREATE_DYEING_DC_FAILURE = 'CREATE_DYEING_DC_FAILURE';

//CREATE USER FORM
export const CREATE_USER_FORM_DYEING_DC = 'CREATE_USER_FORM_DYEING_DC';

// UPDATE PROPERTIES FOR TEAM MASTER
export const UPDATE_DYEING_DC_REQUEST = 'UPDATE_DYEING_DC_REQUEST';
export const UPDATE_DYEING_DC_SUCCESS = 'UPDATE_DYEING_DC_SUCCESS';
export const UPDATE_DYEING_DC_FAILURE = 'UPDATE_DYEING_DC_FAILURE';

// FETCH SINGLE TEAM
export const FETCH_SINGLE_DYEING_DC_REQUEST = 'FETCH_SINGLE_DYEING_DC_REQUEST';
export const FETCH_SINGLE_DYEING_DC_SUCCESS = 'FETCH_SINGLE_DYEING_DC_SUCCESS';
export const FETCH_SINGLE_DYEING_DC_FAILURE = 'FETCH_SINGLE_DYEING_DC_FAILURE';

// DELETE PROPERTIES FOR TEAM MASTER
export const DELETE_DYEING_DC_REQUEST = 'DELETE_DYEING_DC_REQUEST';
export const DELETE_DYEING_DC_SUCCESS = 'DELETE_DYEING_DC_SUCCESS';
export const DELETE_DYEING_DC_FAILURE = 'DELETE_DYEING_DC_FAILURE';

// USERFORM RESET

export const DYEING_DC_USERFORM_RESET = 'DYEING_DC_USERFORM_RESET';

// navigate to unit component
export const NAVIGATE_DYEING_DC_DETAILS = 'NAVIGATE_DYEING_DC_DETAILS';
// navigate to company component
export const NAVIGATE_DYEING_DC = 'NAVIGATE_DYEING_DC';
export const DYEING_DC_USERFORM_NAVIGATE_TO_DETAIL_TAB = 'DYEING_DC_USERFORM_NAVIGATE_TO_DETAIL_TAB';
export const DYEING_DC_USERFORM_NAVIGATE_TO_DETAIL_REVERSE = 'DYEING_DC_USERFORM_NAVIGATE_TO_DETAIL_TAB_REVERSE';

// FETCH ALL PROPERTIES FROM TEAM MASTER
export const FETCH_DYEING_DC_INVOICE_REQUEST = 'FETCH_DYEING_DC_INVOICE_REQUEST';
export const FETCH_DYEING_DC_INVOICE_SUCCESS = 'FETCH_DYEING_DC_INVOICE_SUCCESS';
export const FETCH_DYEING_DC_INVOICE_FAILURE = 'FETCH_DYEING_DC_INVOICE_FAILURE';

export const RESET_DYEING_DC_INVOICE_V2 = 'RESET_DYEING_DC_INVOICE_V2';

export const CHECK_ALL_UPDATE_REQUEST_DYEING = 'CHECK_ALL_UPDATE_REQUEST_DYEING';
export const CHECK_ALL_UPDATE_SUCCESS_DYEING = 'CHECK_ALL_UPDATE_SUCCESS_DYEING';
export const CHECK_ALL_UPDATE_FALIURE_DYEING = 'CHECK_ALL_UPDATE_FALIURE_DYEING';
// CHECK_ALL_UPDATE_REQUEST_DYEING

export const CLOSE_BTN_POST_REQUEST_DYEING = 'CLOSE_BTN_POST_REQUEST_DYEING';
export const CLOSE_BTN_POST_SUCCESS_DYEING = 'CLOSE_BTN_POST_SUCCESS_DYEING';
export const CLOSE_BTN_POST_FALIURE_DYEING = 'CLOSE_BTN_POST_FALIURE_DYEING';


export const DYEING_DC_DIA_REQUEST = 'DYEING_DC_DIA_REQUEST';
export const DYEING_DC_DIA_SUCCESS = 'DYEING_DC_DIA_SUCCESS';
export const DYEING_DC_DIA_FALIURE = 'DYEING_DC_DIA_FALIURE';



export const DYEING_DC_PROGRAM_ID_REQUEST = 'DYEING_DC_PROGRAM_ID_REQUEST';
export const DYEING_DC_PROGRAM_ID_SUCCESS = 'DYEING_DC_PROGRAM_ID_SUCCESS';
export const DYEING_DC_PROGRAM_ID_FAILURE = 'DYEING_DC_PROGRAM_ID_FAILURE';

export const HEADER_SEARCH_CALL_ONLOAD = 'HEADER_SEARCH_CALL_ONLOAD';

export const NAVIGATE_DYEING_DC_PRINT = 'NAVIGATE_DYEING_DC_PRINT';



